import { IProductWithCmsDataAndQualification } from "../../../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";
import { ICmsProductValueDto } from "../../../services/ApiClientBonusxCmsRepository/dtos/cms-product-value/cms-product-value.dto.interface";
import { ProductCashbackForPartner } from "../../../services/ProductCashbackForPartner/ProductCashbackForPartner.service";

export function setProductsWithCashbackIntoGlobalState(products: IProductWithCmsDataAndQualification[]) {
  const productsForPartnerService = new ProductCashbackForPartner(products);

  const productsWithCashback = productsForPartnerService.getProductsCashbackFromPartner();
  window.__CMS_PRODUCT_WITH_CASHBACK_COLLECTION__ = new Map<string, ICmsProductValueDto>(productsWithCashback);
}
